import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './index-color-override.css';
import App from './App';
import './commit-date';

ReactDOM.render(<App />, document.getElementById('root'));
